import type { Config } from 'tailwindcss';
import colors from 'tailwindcss/colors';

export default {
  darkMode: 'class',
  content: ['./src/**/*.{js,jsx,ts,tsx}'],
  theme: {
    colors: {
      grey: colors.gray,
      slate: colors.slate,
    },
    extend: {
      backgroundImage: {
        'default-gradient': 'url(./../public/images/gradient-1_sm.png)',
        // Aurora accent gradient (production default = orange)
        grad: 'linear-gradient(135deg, #ff7a45, #ef4823)',
        'grad-dark': 'linear-gradient(135deg, #ff8a5b, #f5512c)',
      },
      fontFamily: {
        sans: ['Inter', 'ui-sans-serif', 'system-ui', 'sans-serif'],
      },
      borderRadius: {
        lg: '0.5rem',
        xl: '0.75rem',
        '2xl': '1rem',
        '3xl': '1.5rem',
      },
      boxShadow: {
        // card: '0px 3px 8px 0px hsla(265, 10%, 23%, 0.15)',
        card: '0px 4px 16px hsla(0, 0%, 0%, 0.04)',
        'pop-up': '0px 4px 10px 0px hsla(0,0%,0%,0.15)',
        dialog: '0px 6px 15px 0px hsla(0,0%,0%,0.2)',
        sidebar: '0px 4px 20px 0 hsla(0,0%,0%,10%)',
        header: '0px 1px 8px 0 hsla(0,0%,0%,10%)',
        orange: '0px 4px 12px hsla(16, 100%, 61%, 0.4)',
        'orange-card': '0px 6px 12px hsla(16, 100%, 71%, 0.25)',
        'orange-chip': '0px 3px 8px hsla(16 100% 70% / 0.5)',
        // Aurora frosted-glass overlay, card lift, and list-row hover
        glass:
          '0 32px 84px -28px rgba(70,60,90,.32), 0 2px 10px rgba(70,60,90,.06)',
        'glass-dark':
          '0 36px 90px -28px rgba(0,0,0,.7), 0 2px 10px rgba(0,0,0,.45)',
        'aurora-card':
          '0 1px 2px rgba(40,30,30,.04), 0 14px 34px -16px rgba(60,50,60,.12)',
        'row-hover': '0 12px 26px -16px rgba(241,90,43,.34)',
      },
      transitionProperty: {
        width: 'width',
      },
      colors: {
        transparent: 'transparent',
        white: '#fff',
        black: '#1b2932',
        // 'site-background': '#f8f9fa',
        'site-background': '#fafafb',
        'dialog-backdrop': '#15181C',
        brand: {
          blue: '#002255',
          orange: '#ff9068',
          // Aurora accent (production default = orange)
          accent: '#f15a2b',
          'accent-dark': '#ff7a4d',
        },
        blue: {
          // 1: '#6bc1f8',
          1: '#E1EFF9',
          2: '#10a2fd',
          3: '#357dd2',
          4: '#255fb0',
          ...colors.blue,
        },
        cyan: {
          1: '#DBF5F7',
          2: '#22d3ee',
          3: '#06b6d4',
          4: '#0e7490',
        },
        emerald: {
          // 1: '#a7f3d0',
          1: '#E4F9F0',
          2: '#6ee7b7',
          3: '#34d399',
          4: '#059669',
        },
        green: {
          1: '#b4f3cf',
          2: '#58bd85',
          3: '#4aa37f',
          4: '#3a8474',
        },
        lime: {
          1: '#d9f99d',
          2: '#bef264',
          3: '#a3e635',
          4: '#84cc16',
        },
        navy: {
          1: '#6c8fe0',
          2: '#234aa4',
          3: '#1a377a',
          4: '#0c2254',
        },
        orange: {
          1: '#ffd1b7',
          2: '#f97b19',
          3: '#ff6b36',
          4: '#cc4700',
          ...colors.orange,
        },
        pink: {
          // 1: '#fecdd3',
          1: '#FCE2E5',
          2: '#fb7195',
          3: '#f43f5e',
          4: '#e11d48',
        },
        purple: {
          1: '#869af4',
          2: '#5370f4',
          3: '#475ece',
          4: '#3449ae',
          ...colors.purple,
        },
        red: {
          1: '#feb3af',
          2: '#f2625a',
          3: '#df2a20',
          4: '#bd180f',
        },
        yellow: {
          1: '#fef08a',
          2: '#fde047',
          3: '#facc15',
          4: '#eab308',
        },
        grey: {
          1: '#fafafa',
          // 2: '#f8f9fc',
          2: '#f3f5f7',
          3: '#e2e6e9',
          4: '#cedfe8',
          5: '#a7c1d2',
          6: '#7e9eb5',
          7: '#496f88',
          8: '#2d4453',
          9: '#121b21',
        },
        // Aurora warm text neutrals (light-mode inks), lightest -> darkest.
        // Primary text = taupe-3, secondary = taupe-2, tertiary/muted = taupe-1.
        taupe: {
          1: '#938b80',
          2: '#5f5a52',
          3: '#1a1510',
        },
        // Aurora cool text neutrals (dark-mode inks), lightest -> darkest.
        // Dark primary = mauve-1, secondary = mauve-2, tertiary/muted = mauve-3.
        mauve: {
          1: '#f3eff8',
          2: '#bfb6cb',
          3: '#8b8299',
        },
      },
    },
  },
  plugins: [],
} satisfies Config;
